<template>
  <div :id="$attrs['id']" :class="[[$attrs['class'], gridClasses], {'hm-colorpicker--active': internalValue}, {'hm-colorpicker--disabled': disabledCombined}]" class="hm-colorpicker">
    <div class="hm-colorpicker__wrapper">
      <div class="hm-colorpicker__label" v-html="label"></div>
      <verte v-model="internalValue"
             :show-history="false"
             :draggable="false"
             :enable-alpha="false"
             picker="square"
             model="hex"
             display="picker"></verte>
    </div>
    <div :title="help" class="hm-colorpicker__help" v-html="help" />
  </div>
</template>

<script>

import HmInputMixin from '@/mixins/HmInputMixin';
import GridMixin from '@/mixins/GridMixin';
import Verte from 'verte';
import 'verte/dist/verte.css';


export default {
  name: 'HmColorPicker',
  components: { Verte },

  mixins: [HmInputMixin, GridMixin],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '~styles/import';
  .hm-colorpicker {
    &--active {
      .hm-colorpicker {
        &__colorpicker {
          &__wrapper {
            background-color: $mint;
          }
          &__handle {
            left: calc(100% - 1.5rem);
            &:before, &:after {
              transform: rotate(0);
            }
          }
        }
      }
    }
    &--disabled {
      &.hm-colorpicker {
        cursor: not-allowed !important;
      }
      .hm-colorpicker {
        &__label {
          color: $gray;
        }
        &__colorpicker {
          pointer-events: none;
          &__wrapper {
            background-color: $white;
            border: 0.1rem solid $middlegray;
          }
        }
      }
    }
    &__wrapper {
      width: 100%;
      display: grid;
      grid-template-columns: 8fr min-content;
      align-items: center;
      border-bottom: 0.1rem solid $middlegray;
      height: 3.8rem;
    }
    &__colorpicker {
      justify-self: end;
      &:hover {
        cursor: pointer;
      }
      &__wrapper {
        width: 3.2rem;
        height: 1.7rem;
        background-color: $middlegray;
        border-radius: 1.5rem;
        position: relative;
        display: inline-block;
      }
      &__handle {
        position: absolute;
        left: 0;
        top: 0rem;
        width: 1.5rem;
        height: 1.5rem;
        background-color: $white;
        border-radius: 50%;
        box-shadow: 0.1rem 0.1rem 0.2rem 0 rgba($black,0.5);
        transition: left 0.2s ease-in;
        will-change: left;
        &:before {
          content: '';
          position: absolute;
          width: 0.1rem;
          height: 0.8rem;
          margin-top: -0.4rem;
          background-color: $middlegray;
          left: 50%;
          top: 50%;
          transform: rotate(-45deg);
          transition: transform 0.2s ease-in;
          will-change: transform;
        }
        &:after {
          content: '';
          position: absolute;
          width: 0.1rem;
          height: 0.8rem;
          margin-top: -0.4rem;
          background-color: $middlegray;
          left: 50%;
          top: 50%;
          transform: rotate(45deg);
          transition: transform 0.2s ease-in;
          will-change: transform;
        }
      }
    }
    &__label {
      padding-left: 1rem;
    }
    &__help {
      color: $gray;
      font-size: 1.1rem;
      padding-left: 1rem;
      height: 1.4rem;
      line-height: 1.4rem;
      margin-bottom: 0.3rem;
      margin-top: 0.3rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
</style>

<style lang="scss">
@import '~styles/import';

.verte__submit {
  svg {
    path {
      transition: color 0.3s ease, fill 0.3s ease;
      color: $middlegray;
      fill: $middlegray;
    }
  }

  &:hover {
    svg {
      path {
        color: $mint;
        fill: $mint;
      }
    }
  }
}

.verte__menu {
  border: 0.1rem solid $middlegray!important;
  border-radius: 0!important;
  box-shadow: 0 6px 15px 0 rgba($black,0.35)!important;
  box-sizing: content-box;

  .verte__close {
    background-color: $middlegray!important;
    transition: background-color 0.3s ease;
    box-shadow: 0.1rem 0.1rem 0.2rem 0 rgba($black,0.5);

    &:hover {
      background-color: $gray!important;
    }
  }
}

.verte__guide {
  box-shadow: 0.1rem 0.1rem 0.2rem 0 rgba($black,0.5);
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/lib/inputs/HmColorPicker.vue